import { ELEMENT_LINK } from '@udecode/slate-plugins';
import { Link } from '../../components';

import isUrl from '../../../../utils/isUrl';

const defaultLink = {
  link: {
    component: Link,
    type: ELEMENT_LINK,
    isUrl,
    rootProps: {
      className: 'slate-link',
    },
  },
};

export default defaultLink;
